export const DefaultTranslation = Object.freeze({
  meta: {
    text: 'Türkçe',
    value: 'tr-TR',
    info: 'Türkçe',
  },
  commons: {
    titles: {
      edit: 'Düzenle',
      delete: 'Sil',
      dragToSort: 'Sürükleyerek Sırala',
      download: 'İndir',
      copyText: 'Metni Kopyala',
      copyCoordinates: 'Koordinatları Kopyala',
      showLayer: 'Katmanı Göster',
      rename: 'Yeniden Adlandır',
      toggleSection: 'Genişlet/Daralt',
      toggleVisibility: 'Görünürlüğü Değiştir',
      zoomToCoordinates: 'Koordinatlara Yakınlaştır',
    },
    types: {
      convertable: {
        drawing: 'Çizim',
        measurement: 'Ölçüm',
      },
    },
  },
  managers: {
    settingsManager: {
      settings: {
        mouseWheelZoom: 'Sadece Fare Tekerleği ile Haritayı Yakınlaştır',
        altShiftDragRotate: 'Shift + Alt + Sürükle ile Haritayı Döndür',
        dragPan: 'Sadece Fare ile Haritayı Sürükle',
        keyboardZoom: 'Klavye ile Haritayı Yakınlaştır',
        keyboardPan: 'Klavye ile Haritayı Kaydır',
        selectVectorMapShapes: 'Vektör Harita Katmanlarındaki Şekilleri Seç',
        snapInteraction: 'Hizalama Etkileşimini Kullan',
        snapHelpLines: 'Hizalama Yardım Çizgilerini Kullan',
        alwaysNewLayers: 'Araç Seçilirken Yeni Katman Oluştur',
      },
    },
    errorManager: {
      toasts: {
        errors: {
          uncaughtException: {
            title: 'Hata',
            message: 'Beklenmedik bir hata oluştu',
          },
        },
      },
    },
    infoWindowManager: {
      toasts: {
        infos: {
          copyMarkerCoordinates: {
            title: 'Kopyalandı',
            message: 'İşaretçi koordinatları panoya kopyalandı',
          },
          copyMarkerInfo: {
            title: 'Kopyalandı',
            message: 'İşaretçi bilgileri panoya kopyalandı',
          },
        },
        errors: {
          copyMarkerInfo: {
            title: 'Hata',
            message: 'İşaretçi bilgileri kopyalanamadı',
          },
          copyMarkerCoordinates: {
            title: 'Hata',
            message: 'İşaretçi koordinatları kopyalanamadı',
          },
        },
      },
      dialogs: {
        confirms: {
          deleteMarker: {
            title: 'İşaretçiyi Sil',
            message: 'Bu İşaretçiyi silmek istiyor musunuz?',
            confirmText: 'Sil',
            cancelText: 'İptal',
          },
        },
      },
    },
  },
  modalExtensions: {
    coordinateModal: {
      title: 'Koordinatlar',
      form: {
        latitude: 'Enlem',
        longitude: 'Boylam',
        navigateTo: 'Git',
        cancel: 'İptal',
        description: 'Koordinatlar şu şekilde verilmiştir WGS84/EPSG:4326',
      },
    },
    debugInfoModal: {
      title: 'Hata Ayıklama Bilgileri',
      noMapFound: 'Harita referansı bulunamadı',
      form: {
        doAction: 'Eylem Yapın',
        defaultItem: {
          title: 'Eylem Seç',
        },
        miscGroup: {
          title: 'Çeşitli',
          items: {
            logToBrowser: 'Haritayı Tarayıcı Konsoluna Yazdır',
            generateUUID: 'UUID Oluştur',
            clearStyleManager: 'Stil Yöneticisini Temizle',
          },
        },
        eventLogGroup: {
          title: 'Olay Günlüğü',
          items: {
            copyEventLog: 'Olay Günlüğünü Kopyala',
            clearEventLog: 'Olay Günlüğünü Temizle',
          },
        },
      },
      sections: {
        appData: 'Uygulama Verisi',
        mapData: 'Harita Verisi',
        browserData: 'Tarayıcı Verisi',
        localStorage: 'Yerel Depolama',
        sessionStorage: 'Oturum Depolama',
        cookies: 'Çerezler',
        eventLog: 'Olay Günlüğü',
      },
      toasts: {
        infos: {
          logMapObject: {
            title: 'Günlük Kaydı Alındı',
            message: 'Harita nesnesi konsola yazdırıldı',
          },
          copyEventLog: {
            title: 'Kopyalandı',
            message: 'Olay günlüğü panoya kopyalandı',
          },
          clearEventLog: {
            title: 'Temizlendi',
            message: 'Olay günlüğü tüm girişlerden temizlendi',
          },
          clearStyleManager: {
            title: 'Temizlendi',
            message: 'Stil yöneticisi tüm öğelerden temizlendi',
          },
        },
        errors: {
          copyEventLog: {
            title: 'Hata',
            message: 'Olay günlüğü panoya kopyalanamadı',
          },
        },
      },
    },
    downloadLayerModal: {
      title: 'Katmanı İndir',
      form: {
        layerFormat: 'Katman Formatı',
        download: 'Katmanı İndir',
        cancel: 'İptal',
      },
    },
    geometryDataModal: {
      title: 'Geometri Verisi',
      data: {
        id: 'Kimlik',
        measurement: 'Ölçüm',
        oltbProperties: 'OLTB Properties',
        vertices: 'Köşeler',
        coordinates: 'Koordinatlar',
      },
    },
    iconMarkerModal: {
      title: 'İşaretçi Yapılandırması',
      form: {
        title: 'Başlık',
        description: 'Açıklama',
        latitude: 'Enlem',
        longitude: 'Boylam',
        markerFill: 'İşaretçi Dolgusu',
        markerStroke: 'İşaretçi Çizgisi',
        icon: 'Simge',
        iconFill: 'Simge Dolgusu',
        iconStroke: 'Simge Çizgisi',
        label: 'Etiket',
        labelFill: 'Etiket Dolgusu',
        labelStroke: 'Etiket Çizgisi',
        labelStrokeWidth: 'Etiket Çizgi Kalınlığı',
        saveChanges: 'Değişiklikleri Kaydet',
        createMarker: 'İşaretçi Oluştur',
        cancel: 'İptal',
      },
    },
    importLayerModal: {
      title: 'Katman Yükle',
      form: {
        featureProjection: 'Özellik Projeksiyonu',
        dataProjection: 'Veri Projeksiyonu',
        import: 'Katman Yükle',
        cancel: 'İptal',
      },
    },
    layerModal: {
      title: 'Harita Katmanı Oluştur',
      form: {
        name: 'Ad',
        layer: 'Layer',
        source: 'Kaynak',
        projection: 'Projeksiyon',
        url: 'URL',
        parameters: 'Parametreler (JSON)',
        wrapX: 'X Sar',
        cors: 'CORS',
        attributions: 'Atıflar',
        createLayer: 'Katman Oluştur',
        cancel: 'İptal',
      },
    },
    settingsModal: {
      title: 'Ayarlar',
      form: {
        save: 'Ayarları Kaydet',
        cancel: 'İptal',
      },
    },
  },
  tools: {
    hiddenAboutTool: {
      contextItems: {
        about: 'OLTB Hakkında',
      },
      modals: {
        about: {
          title: 'OLTB Hakkında',
          version: '1.1',
          developedBy: 'SOLVERA Tarafından Geliştirildi',
          usingOpenLayers: 'OpenLayers Kullanıyor',
        },
      },
    },
    hiddenMapNavigationTool: {
      contextItems: {
        copyCoordinates: 'Koordinatları Kopyala',
        navigateToCoordinates: 'Git',
        centerMap: 'Buraya Merkezle',
        focusMap: 'Buraya Odaklan',
      },
      toasts: {
        infos: {
          coordinatesCopied: {
            title: 'Kopyalandı',
            message: 'Koordinatlar panoya kopyalandı',
          },
        },
        errors: {
          coordinatesCopy: {
            title: 'Hata',
            message: 'Koordinatlar kopyalanamadı',
          },
          parseUrlMarker: {
            title: 'Hata',
            message: 'URL işaretçisi çözümlenemedi',
          },
          missingProjection: {
            title: 'Hata',
            message: 'Projeksiyon tanımı eksik',
          },
        },
      },
    },
    hiddenMarkerTool: {
      contextItems: {
        createMarker: 'İşaretçi Oluştur',
      },
    },
    bookmarkTool: {
      title: 'Yer İmleri',
      toolbox: {
        titles: {
          bookmarks: 'Yer İmleri',
        },
        groups: {
          addBookmark: {
            placeholder: 'Ad',
            add: 'Yer İmi Ekle',
          },
        },
      },
      contextItems: {
        addBookmark: 'Yer İmi Ekle',
        clearBookmarks: 'Yer İmlerini Temizle',
      },
      layers: {
        bookmarks: 'Yer İmleri',
      },
      toasts: {
        infos: {
          clearBookmarks: {
            title: 'Temizlendi',
            message: 'Tüm kayıtlı yer imleri temizlendi',
          },
          createBookmark: {
            title: 'Yeni Yer İmi',
            message: 'Yeni bir yer imi oluşturuldu',
          },
          copyCoordinates: {
            title: 'Kopyalandı',
            message: 'Koordinatlar panoya kopyalandı',
          },
        },
        errors: {
          copyCoordinates: {
            title: 'Hata',
            message: 'Koordinatlar kopyalanamadı',
          },
        },
      },
      dialogs: {
        confirms: {
          clearBookmarks: {
            title: 'Yer İmlerini Temizle',
            message: 'Tüm yer imlerini temizlemek istiyor musunuz?',
            confirmText: 'Temizle',
            cancelText: 'İptal',
          },
          deleteBookmark: {
            title: 'Yer İmini Sil',
            message: 'Yer imini silmek istiyor musunuz?',
            confirmText: 'Sil',
            cancelText: 'İptal',
          },
        },
        prompts: {
          editBookmark: {
            title: 'Adı Düzenle',
            message: 'Bir yer imini düzenliyorsunuz',
            confirmText: 'Yeniden Adlandır',
            cancelText: 'İptal',
          },
        },
      },
    },
    coordinatesTool: {
      title: 'Koordinatları Göster',
      toolbox: {
        titles: {
          coordinates: 'Koordinatlar',
        },
        groups: {
          formats: {
            title: 'Format',
            dd: 'Ondalık Derece',
            dms: 'Derece, Dakika, Saniye',
          },
          coordinates: {
            title: 'Koordinatlar',
          },
        },
      },
      settings: {
        copyOnClick: 'Tıklayınca Koordinatları Kopyala',
        updateToolboxOnHover: 'Üzerine Gelince Koordinat Kutusunu Güncelle',
      },
      toasts: {
        infos: {
          copyCoordinates: {
            title: 'Kopyalandı',
            message: 'Koordinatlar panoya kopyalandı',
          },
        },
        errors: {
          copyCoordinates: {
            title: 'Hata',
            message: 'Koordinatlar kopyalanamadı',
          },
        },
      },
    },
    debugInfoTool: {
      title: 'Debug Info',
    },
    directionTool: {
      title: 'Yönü Değiştir',
    },
    drawTool: {
      title: 'Çiz',
      toolbox: {
        titles: {
          draw: 'Çiz',
        },
        groups: {
          shapes: {
            title: 'Şekil',
            circle: 'Daire',
            square: 'Kare',
            rectangle: 'Dikdörtgen',
            lineString: 'Çizgi',
            point: 'Nokta',
            polygon: 'Çokgen',
          },
          intersectable: {
            title: 'Kesişim',
            true: 'Evet',
            false: 'Hayır',
          },
          strokeWidth: {
            title: 'Çizgi Kalınlığı',
          },
          strokeColor: {
            title: 'Çizgi Rengi',
          },
          fillColor: {
            title: 'Dolgu Rengi',
          },
        },
      },
      layers: {
        defaultName: 'Çizim Katmanı',
      },
      toasts: {
        infos: {
          drawInHiddenLayer: {
            title: 'İpucu',
            message: 'Gizli bir katmanda çizim yapıyorsunuz',
          },
          missingIntersections: {
            title: 'Uyarı',
            message: 'Kesişen nesne bulunamadı',
          },
        },
      },
    },
    areaviewTool: {
      title: 'Alan Göster',
      toolbox: {
        titles: {
          draw: 'Alan Göster',
        },
        groups: {
          bolumler: {
            jeofizikTitle: 'Jeofizik Çalışmalar',
            jeolojiTitle: 'Jeoloji Çalışmalar',
            haritaTitle: 'Haritalar',
            planturuTitle: 'Plan Türü',
          },
          shapes: {
            title: 'Şekil',
            circle: 'Daire',
            square: 'Kare',
            rectangle: 'Dikdörtgen',
            lineString: 'Çizgi',
            point: 'Nokta',
            polygon: 'Çokgen',
          },
          intersectable: {
            title: 'Kesişim',
            true: 'Evet',
            false: 'Hayır',
          },
          strokeWidth: {
            title: 'Çizgi Kalınlığı',
          },
          strokeColor: {
            title: 'Çizgi Rengi',
          },
          fillColor: {
            title: 'Dolgu Rengi',
          },
        },
      },
      layers: {
        defaultName: 'Çizim Katmanı',
      },
      toasts: {
        infos: {
          drawInHiddenLayer: {
            title: 'İpucu',
            message: 'Gizli bir katmanda çizim yapıyorsunuz',
          },
          missingIntersections: {
            title: 'Uyarı',
            message: 'Kesişen nesne bulunamadı',
          },
        },
      },
    },
    editTool: {
      title: 'Düzenle',
      toolbox: {
        titles: {
          edit: 'Düzenle',
        },
        groups: {
          misc: {
            title: 'Diğer',
            delete: 'Sil',
            rotate: 'Döndür',
            geometryData: 'Geometri Verisi',
            convertFeature: 'Dönüştür',
          },
          copying: {
            title: 'Pano',
            cut: 'Kes',
            copy: 'Kopyala',
            paste: 'Yapıştır',
          },
          shapes: {
            title: 'Şekiller',
            union: 'Birleştir',
            intersect: 'Kesiştir',
            exclude: 'Hariç Tut',
            difference: 'Farkını Al',
          },
          strokeColor: {
            title: 'Çizgi Rengi',
          },
          fillColor: {
            title: 'Dolgu Rengi',
          },
        },
      },
      settings: {
        mouseOnlyToEditVectorShapes: 'Vektör Şekilleri Sadece Fare ile Düzenle',
      },
      toasts: {
        infos: {
          copiedFeatures: {
            title: 'Kopyalandı',
            message: 'Nesneler kopyalandı',
          },
          pastedFeatures: {
            title: 'Yapıştırıldı',
            message: 'Nesneler yapıştırıldı',
          },
          cutFeatures: {
            title: 'Kesildi',
            message: 'Nesneler kesildi',
          },
          missingFeatures: {
            title: 'Uyarı',
            message: 'Seçili nesne yok',
          },
          strictOneFeature: {
            title: 'Uyarı',
            message: 'Yalnızca bir nesne seçilebilir',
          },
          strictTwoFeatures: {
            title: 'Uyarı',
            message: 'Tam olarak iki çakışan nesne seçilmelidir',
          },
        },
        errors: {
          operationFailed: {
            title: 'Hata',
            message: 'Şekil işlemi gerçekleştirilemedi',
          },
          invalidValue: {
            title: 'Hata',
            message: 'Yalnızca rakam girişi yapılabilir',
          },
        },
      },
      dialogs: {
        confirms: {
          deleteFeatures: {
            title: 'Sil',
            message: 'Seçili nesneleri silmek istiyor musunuz?',
            confirmText: 'Sil',
            cancelText: 'İptal',
          },
        },
        prompts: {
          rotateFeatures: {
            title: 'Döndür',
            message: 'Nesneleri derece cinsinden döndürün',
            confirmText: 'Döndür',
            cancelText: 'İptal',
          },
          convertFeatures: {
            title: 'Dönüştür',
            message: 'Seçili nesneleri dönüştür',
            confirmText: 'Dönüştür',
            cancelText: 'İptal',
          },
        },
      },
    },
    exportPngTool: {
      title: 'PNG Dışa Aktar',
      toasts: {
        errors: {
          renderCanvas: {
            title: 'Hata',
            message: 'PNG dışa aktarılamadı',
          },
        },
      },
    },
    fullscreenTool: {
      title: 'Tam Ekran Modunu Aç/Kapat',
      toasts: {
        errors: {
          missingFullScreenSupport: {
            title: 'Hata',
            message: 'Bu tarayıcı tam ekran modunu desteklemiyor',
          },
        },
      },
    },
    graticuleTool: {
      title: 'Kılavuz Çizgilerini Göster',
    },
    helpTool: {
      title: 'Yardım',
      dialogs: {
        confirms: {
          openHelp: {
            title: 'Yardım Sayfaları',
            message: 'Tarayıcılar yeni pencereleri otomatik açmayı engelleyebilir, lütfen bu butona tıklayın',
            confirmText: 'Yardımı Aç',
            cancelText: 'İptal',
          },
        },
      },
      toasts: {
        errors: {
          blockedByBrowser: {
            title: 'Hata',
            message: 'İşlem tarayıcı ayarları tarafından engellendi',
          },
        },
      },
    },
    homeTool: {
      title: 'Ana Konuma Yakınlaştır',
      contextItems: {
        setHome: 'Ana Konumu Belirle',
      },
      toasts: {
        infos: {
          setHomeLocation: {
            title: 'Yeni Ana Konum',
            message: 'Yeni konum ana konum olarak ayarlandı',
          },
        },
      },
    },
    importVectorLayerTool: {
      title: 'Vektör Katmanını İçe Aktar',
      toasts: {
        errors: {
          unsupportedFormat: {
            title: 'Hata',
            message: 'Katman formatı desteklenmiyor',
          },
          importFailed: {
            title: 'Hata',
            message: 'Vektör katmanı içe aktarılamadı',
          },
        },
      },
    },
    infoTool: {
      title: 'Bilgi',
    },
    layerTool: {
      title: 'Katmanlar',
      toolbox: {
        titles: {
          mapLayers: 'Haritalar',
          featureLayers: 'Katmanlar',
        },
        groups: {
          createMapLayer: {
            placeholder: 'Ad',
            create: 'Harita Ekle',
          },
          createFeatureLayer: {
            placeholder: 'Ad',
            create: 'Katman Ekle',
          },
        },
      },
      contextItems: {
        addMapLayer: 'Harita Ekle',
        addFeatureLayer: 'Katman Ekle',
      },
      toasts: {
        infos: {
          addFeatureLayer: {
            title: 'Yeni Katman',
            message: 'Yeni bir özellik katmanı oluşturuldu',
          },
        },
        errors: {
          addFeatureLayer: {
            title: 'Hata',
            message: 'Yeni katman oluşturulamadı',
          },
          missingProjection: {
            title: 'Hata',
            message: 'Projeksiyon tanımı eksik',
          },
          unsupportedFormat: {
            title: 'Hata',
            message: 'Katman formatı desteklenmiyor',
          },
        },
      },
      dialogs: {
        prompts: {
          renameLayer: {
            title: 'Adı Düzenle',
            message: 'Katmanın adını düzenlemek istiyor musunuz?',
            confirmText: 'Yeniden Adlandır',
            cancelText: 'İptal',
          },
        },
        confirms: {
          deleteLayer: {
            title: 'Katmanı Sil',
            message: 'Katmanı silmek istiyor musunuz?',
            confirmText: 'Sil',
            cancelText: 'İptal',
          },
        },
      },
    },
    magnifyTool: {
      title: 'Büyüt',
      toasts: {
        errors: {
          renderCanvas: {
            title: 'Hata',
            message: 'Büyüteç kullanılırken beklenmeyen bir hata oluştu',
          },
        },
      },
    },
    measureTool: {
      title: 'Ölç',
      toolbox: {
        titles: {
          measure: 'Ölç',
        },
        groups: {
          type: {
            title: 'Tür',
            lineString: 'Uzunluk',
            polygon: 'Alan',
          },
          strokeColor: {
            title: 'Çizgi Rengi',
          },
          fillColor: {
            title: 'Dolgu Rengi',
          },
        },
      },
      layers: {
        defaultName: 'Ölçüm Katmanı',
      },
      toasts: {
        infos: {
          drawInHiddenLayer: {
            title: 'İpucu',
            message: 'Gizli bir katmanda ölçüm yapıyorsunuz',
          },
        },
      },
    },
    myLocationTool: {
      title: 'Konumum',
      dialogs: {
        confirms: {
          exitFullscreen: {
            title: 'Tam Ekrandan Çık',
            message: 'Coğrafi konumu kullanmak için tam ekrandan çıkmanız gerekiyor',
            confirmText: 'Tam Ekrandan Çık',
            cancelText: 'İptal',
          },
        },
      },
      toasts: {
        infos: {
          fetchLocation: {
            title: 'Aranıyor',
            message: 'Konumunuz bulunmaya çalışılıyor...',
          },
        },
        errors: {
          exitFullscreen: {
            title: 'Hata',
            message: 'Tam ekrandan çıkılamadı',
          },
          locationNotFound: {
            title: 'Hata',
            message: 'Konum bulunamadı',
          },
        },
      },
    },
    overviewTool: {
      title: 'Harita Genel Görünümü',
      toolbox: {
        titles: {
          overview: 'Harita Genel Görünümü',
        },
      },
    },
    refreshTool: {
      title: 'Sayfayı Yenile',
    },
    resetNorthTool: {
      title: 'Kuzeyi Sıfırla',
      contextItems: {
        rotate: 'Haritayı Döndür',
      },
      dialogs: {
        prompts: {
          rotateMap: {
            title: 'Haritayı Döndür',
            message: 'Haritanın dönüşünü derece cinsinden ayarlayın',
            confirmText: 'Döndür',
            cancelText: 'İptal',
          },
        },
      },
      toasts: {
        errors: {
          invalidValue: {
            title: 'Hata',
            message: 'Yalnızca rakam girişi yapılabilir',
          },
        },
      },
    },
    scaleLineTool: {
      title: 'Ölçek Çizgisi',
    },
    scissorsTool: {
      title: 'Çokgen Makası',
      toasts: {
        infos: {
          missingIntersections: {
            title: 'Uyarı',
            message: 'Kesişen nesne bulunamadı',
          },
        },
      },
    },
    settingsTool: {
      title: 'Ayarlar',
      contextItems: {
        clearBrowserState: 'Tarayıcı Durumunu Temizle',
      },
      toasts: {
        infos: {
          clearBrowserState: {
            title: 'Temizlendi',
            message: 'Tüm kayıtlı öğeler varsayılan ayarlara sıfırlandı',
          },
        },
        successes: {
          savedSettings: {
            title: 'Kaydedildi',
            message: 'Tüm ayarlar tarayıcıda kaydedildi',
          },
        },
      },
      dialogs: {
        confirms: {
          clearBrowserState: {
            title: 'Tarayıcı Durumunu Temizle',
            message: 'Araç çubuğu için tüm öğeleri varsayılan duruma sıfırlamak istiyor musunuz?',
            confirmText: 'Temizle',
            cancelText: 'İptal',
          },
        },
      },
    },
    splitViewTool: {
      title: 'Bölünmüş Görünüm',
      toolbox: {
        titles: {
          splitView: 'Bölünmüş Görünüm',
        },
        groups: {
          leftSide: {
            title: 'Sol Taraf',
          },
          rightSide: {
            title: 'Sağ Taraf',
          },
          swapSides: {
            swap: 'Tarafları Değiştir',
          },
        },
        toasts: {
          infos: {
            strictOneLayer: {
              title: 'İpucu',
              message: 'Birden fazla katmanınız olmalı',
            },
          },
          errors: {
            layerFailedToLoad: {
              title: 'Hata',
              message: 'Katman(lar) yüklenemedi',
            },
          },
        },
      },
    },
    themeTool: {
      title: 'Temayı Değiştir',
    },
    toolboxTool: {
      title: 'Araç Kutusunu Değiştir',
    },
    translationTool: {
      title: 'Çevir',
      dialogs: {
        selects: {
          changeLanguage: {
            title: 'Dil',
            message: 'Geçerli dil',
            confirmText: 'Dili Değiştir',
            cancelText: 'İptal',
          },
        },
      },
    },
    zoomboxTool: {
      title: 'Yakınlaştırma Kutusu',
      tooltips: {
        dragToZoom: 'Yakınlaştırmak İçin Sürükle',
      },
    },
    zoomInTool: {
      title: 'Yakınlaştır',
    },
    zoomOutTool: {
      title: 'Uzaklaştır',
    },
  },
});
